import React from 'react';
export var TimedElementContext = /*#__PURE__*/React.createContext({
  setShownInSession: function setShownInSession() {
    return null;
  },
  forceShow: function forceShow() {
    return null;
  },
  shouldShow: false
});
export var TimedElementProvider = TimedElementContext.Provider;